import { DEFAULT_PALETTE } from '../../core/palette';
import type { ParamSchema, SchemaValues } from '../../core/params/types';

export const DISPLACEMENT_PARAMS = [
  {
    kind: 'float',
    key: 'amplitude',
    label: 'Amplitude',
    min: 0,
    max: 160,
    step: 0.5,
    default: 14,
    unit: 'px',
    bulkRange: [2, 60],
    group: 'Verschiebung',
    tooltip: 'Wie weit die Konturpunkte entlang ihrer Normalen wandern.',
  },
  {
    kind: 'float',
    key: 'frequency',
    label: 'Frequenz',
    min: 0.2,
    max: 80,
    step: 0.1,
    scale: 'log',
    default: 9,
    group: 'Verschiebung',
    tooltip: 'Wellen pro Umlauf entlang der Kontur.',
  },
  {
    kind: 'int',
    key: 'smoothing',
    label: 'Glättung',
    min: 0,
    max: 12,
    step: 1,
    default: 1,
    group: 'Verschiebung',
    tooltip: 'Mittelt die Verschiebung mit den Nachbarpunkten — dämpft harte Zacken.',
  },
  {
    kind: 'enum',
    key: 'mode',
    label: 'Richtung',
    default: 'both',
    segmented: true,
    group: 'Verschiebung',
    options: [
      { value: 'out', label: 'Aussen' },
      { value: 'in', label: 'Innen' },
      { value: 'both', label: 'Beidseitig' },
    ],
  },
  {
    kind: 'bool',
    key: 'jagged',
    label: 'Zackig statt weich',
    default: false,
    group: 'Verschiebung',
    tooltip: 'Ersetzt die weiche Welle durch Zufallssprünge pro Punkt.',
  },

  {
    kind: 'int',
    key: 'contours',
    label: 'Wiederholungskonturen',
    min: 1,
    max: 60,
    step: 1,
    default: 9,
    bulkRange: [1, 24],
    group: 'Darstellung',
  },
  {
    kind: 'float',
    key: 'offset',
    label: 'Konturabstand',
    min: -30,
    max: 60,
    step: 0.5,
    default: 9,
    unit: 'px',
    group: 'Darstellung',
    showIf: (v) => (v.contours as number) > 1,
  },
  {
    kind: 'float',
    key: 'amplitudeGrowth',
    label: 'Amplitudenzuwachs',
    min: 0,
    max: 3,
    step: 0.05,
    default: 0.9,
    group: 'Darstellung',
    tooltip: 'Wie viel stärker jede weitere Kontur verzerrt wird.',
    showIf: (v) => (v.contours as number) > 1,
  },
  {
    kind: 'enum',
    key: 'style',
    label: 'Stil',
    default: 'stroke',
    segmented: true,
    group: 'Darstellung',
    options: [
      { value: 'fill', label: 'Füllung' },
      { value: 'stroke', label: 'Kontur' },
    ],
  },
  {
    kind: 'float',
    key: 'lineWidth',
    label: 'Strichstärke',
    min: 0.2,
    max: 16,
    step: 0.1,
    default: 1.3,
    unit: 'px',
    group: 'Darstellung',
    showIf: (v) => v.style === 'stroke',
  },
  {
    kind: 'float',
    key: 'opacity',
    label: 'Deckkraft',
    min: 0.03,
    max: 1,
    step: 0.01,
    default: 0.8,
    group: 'Darstellung',
  },

  {
    kind: 'palette',
    key: 'palette',
    label: 'Palette',
    default: { ...DEFAULT_PALETTE, paletteId: 'neon' },
    group: 'Farbe',
  },
] as const satisfies ParamSchema;

export type DisplacementValues = SchemaValues<typeof DISPLACEMENT_PARAMS>;
